export default "__VITE_ASSET__cd9dd652__"